let overlayEscapeHandler = null;
let overlayCurtainClickHandler = null;
let overlayCurtainEl = null;
let overlayCloseClickHandler = null;
let overlayCloseLinkEl = null;
let overlayEl = null;
let overlayIsClosing = false;

function cleanupOverlayHandlers() {
  if (overlayEscapeHandler) {
    document.removeEventListener("keydown", overlayEscapeHandler);
    overlayEscapeHandler = null;
  }

  if (overlayCurtainEl && overlayCurtainClickHandler) {
    overlayCurtainEl.removeEventListener("click", overlayCurtainClickHandler);
  }
  if (overlayCloseLinkEl && overlayCloseClickHandler) {
    overlayCloseLinkEl.removeEventListener("click", overlayCloseClickHandler);
  }

  overlayCurtainEl = null;
  overlayCurtainClickHandler = null;
  overlayCloseLinkEl = null;
  overlayCloseClickHandler = null;
  overlayEl = null;
  overlayIsClosing = false;
}

function getDurationMs() {
  const raw = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue("--anim-speed")
    .trim();

  const value = Number.parseFloat(raw);
  if (!Number.isFinite(value) || value <= 0) return 400;
  if (raw.endsWith("ms")) return value;
  return value * 1000;
}

function navigateTo(href) {
  if (window.swup && typeof window.swup.navigate === "function") {
    window.swup.navigate(href);
    return;
  }

  window.location.assign(href);
}

function closeOverlay(closeLink) {
  if (overlayIsClosing) return;
  overlayIsClosing = true;

  const rootOverlay = overlayEl || document.querySelector(".c-overlay");
  if (rootOverlay instanceof HTMLElement) {
    rootOverlay.classList.add("is-closing");
  }

  const href = closeLink?.getAttribute("href")?.trim() || "";
  const fallbackHref = window.location.origin + "/";
  const targetHref = href || fallbackHref;

  window.setTimeout(() => {
    if (href) {
      navigateTo(targetHref);
      return;
    }

    if (window.history.length > 1) {
      window.history.back();
      return;
    }

    navigateTo(targetHref);
  }, getDurationMs());
}

export function initOverlayClose() {
  cleanupOverlayHandlers();

  const overlay = document.querySelector(".c-overlay");
  if (!(overlay instanceof HTMLElement)) return;
  overlayEl = overlay;

  const closeLink = overlay.querySelector(".c-overlay__close");
  const curtain = overlay.querySelector(".c-overlay__curtain");
  if (!(closeLink instanceof HTMLAnchorElement) || !(curtain instanceof HTMLElement)) return;

  overlayEscapeHandler = (event) => {
    if (!(event instanceof KeyboardEvent) || event.key !== "Escape") return;
    event.preventDefault();
    closeOverlay(closeLink);
  };

  overlayCurtainClickHandler = (event) => {
    if (!(event.target instanceof Element) || event.target !== curtain) return;
    event.preventDefault();
    closeOverlay(closeLink);
  };

  overlayCloseClickHandler = (event) => {
    event.preventDefault();
    closeOverlay(closeLink);
  };

  overlayCurtainEl = curtain;
  overlayCloseLinkEl = closeLink;
  document.addEventListener("keydown", overlayEscapeHandler);
  curtain.addEventListener("click", overlayCurtainClickHandler);
  closeLink.addEventListener("click", overlayCloseClickHandler);
}
